// Phase 5 (web revival) — Stream D.
//
// 8 named CoreImage filters plus a "None" entry. Selecting "None" drops
// the filter op entirely so the wire payload is empty for the no-filter
// case.

import type { FilterName } from '../../api/types';

interface FilterPickerProps {
  value: FilterName | null;
  onChange: (next: FilterName | null) => void;
}

const FILTERS: FilterName[] = [
  'chrome',
  'fade',
  'instant',
  'mono',
  'noir',
  'process',
  'tonal',
  'transfer',
];

export function FilterPicker({ value, onChange }: FilterPickerProps) {
  return (
    <div>
      <h3 className="mb-2 text-xs font-semibold uppercase tracking-wide text-neutral-400">
        Filter
      </h3>
      <div className="grid grid-cols-3 gap-1.5">
        <FilterButton
          label="None"
          active={value === null}
          onClick={() => onChange(null)}
        />
        {FILTERS.map((f) => (
          <FilterButton
            key={f}
            label={f}
            active={value === f}
            onClick={() => onChange(f)}
          />
        ))}
      </div>
    </div>
  );
}

function FilterButton({
  label,
  active,
  onClick,
}: {
  label: string;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        'rounded-md border px-2 py-1.5 text-xs font-medium capitalize transition-colors',
        active
          ? 'border-neutral-200 bg-neutral-200 text-neutral-900'
          : 'border-neutral-800 bg-neutral-950 text-neutral-300 hover:bg-neutral-800',
      ].join(' ')}
    >
      {label}
    </button>
  );
}
